module.exports = __webpack_public_path__ + "img/01125797000540.63839f2d.png";